var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'header-wrapper':true,
  'uk-section-xsmall':true,
  'section-transparent': !_vm.data.dark,
  'uk-section-primary': !(!_vm.data.dark),
}},[_c('h1',{staticClass:"uk-margin-small-bottom"},[_vm._v(_vm._s(_vm.data.header))]),(_vm.data.subheader)?_c('h3',{staticClass:"uk-text-muted uk-margin-remove"},[_vm._v(_vm._s(_vm.data.subheader))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }